export const SESSION_CHANGED = 'brames:session-changed'
export const SESSION_EXPIRED = 'brames:session-expired'

export function getToken() {
	return localStorage.getItem('token') || ''
}

export function saveToken(token) {
	localStorage.setItem('token', token)
	window.dispatchEvent(new Event(SESSION_CHANGED))
}

export function getSessionId() {
	return localStorage.getItem('brames:session-id') || 'legacy'
}

export function startSession(token) {
	// Distinguish a new login from token rotation, so queued requests cannot
	// be replayed on behalf of a different account.
	localStorage.setItem('brames:session-id', `${Date.now()}-${Math.random()}`)
	saveToken(token)
}

export function clearSession() {
	localStorage.removeItem('token')
	localStorage.removeItem('user')
	localStorage.removeItem('brames:session-id')
	window.dispatchEvent(new Event(SESSION_CHANGED))
}

export function expire(expectedToken) {
	if (getToken() && getToken() !== expectedToken) return
	clearSession()
	window.dispatchEvent(new Event(SESSION_EXPIRED))
}

export function withRefreshLock(callback) {
	// Re-read storage after acquiring the lock: another tab may rotate the JWT.
	if (navigator.locks && navigator.locks.request) {
		return navigator.locks.request('brames-auth-refresh', callback)
	}
	return Promise.resolve().then(callback)
}
